import { Size } from './types';

const sizeMapper = {
  small: 'xsmall',
  medium: 'default',
};

export const mapSize = (size: Size) => sizeMapper[size];
